import { DashboardAction } from "../actions";
import { Functions, ApiCaller, Variables } from "../../config";
import info from "../../components/info";
import { put, delay } from "redux-saga/effects";

const companyId = JSON.parse(localStorage.getItem("platform_owner"))?.[1]
  ?.platform_owner?.id;
export default class DashboardMiddleWare {
  static *DashboardCount(action) {
    const { params } = action;
    try {
      let res = yield ApiCaller.Get(`platform_owners/${params}/counts`, {
        "Content-Type": "application/json",
      });
      if (res.status == 200) {
        yield put(DashboardAction.getCountSuccess(res.data.data));

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(DashboardAction.getCountError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(DashboardAction.getCountError());
    }
  }

  static *GetManufacturePlant(action) {
    const { params } = action;
    console.log("Payload params===>", params);
    // const obj = { ...params };
    // if (!obj.start_date || !obj.end_date) {
    //   delete obj.start_date;
    //   delete obj.end_date;
    // }
    const qureyParams = new URLSearchParams(params).toString();
    console.log("queryParams===>", qureyParams);

    try {
      let res = yield ApiCaller.Get(`rmx_companies?${qureyParams}`, {
        "Content-Type": "application/json",
      });
      console.log("orderRes-->", res);

      if (res.status == 200) {
        yield put(
          DashboardAction.getManufacturePlantSuccess(
            res.data.data,
            res.data.meta
          )
        );

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(DashboardAction.getManufacturePlantError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(DashboardAction.getManufacturePlantError());
    }
  }

  static *GetLogisticPartner(action) {
    const { params } = action;
    console.log("params===>", params);
    const obj = { ...params };
    if (!obj.start_date || !obj.end_date) {
      delete obj.start_date;
      delete obj.end_date;
    }
    const qureyParams = new URLSearchParams(obj).toString();
    console.log("queryParams===>", qureyParams);

    try {
      let res = yield ApiCaller.Get(`logistics_partners?${qureyParams}`, {
        "Content-Type": "application/json",
      });

      if (res.status == 200) {
        yield put(
          DashboardAction.getLogisticPartnerSuccess(
            res.data.data,
            res.data.meta
          )
        );

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(DashboardAction.getLogisticPartnerError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(DashboardAction.getLogisticPartnerError());
    }
  }

  static *PlantActivation(action) {
    const { id, cb, params, payload } = action;

    try {
      let res = yield ApiCaller.Put(`rmx_companies/${id}/${params}`, payload);
      if (res.status == 200) {
        info("success", "Plant Status Changed Successfully!");
        yield put(DashboardAction.plantActivationSuccess(res.data.data));
        cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
      } else {
        yield put(DashboardAction.plantActivationError());
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(DashboardAction.plantActivationError());
    }
  }

  static *PlantRejection(action) {
    const { id, cb, params } = action;
    try {
      let res = yield ApiCaller.Put(`rmx_companies/${id}/${params}`);
      if (res.status == 200) {
        yield put(DashboardAction.plantRejectionSuccess(res.data.data));
        cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
      } else {
        yield put(DashboardAction.plantRejectionError());
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(DashboardAction.plantRejectionError());
    }
  }

  static *LogisticsActivation(action) {
    const { id, cb, params } = action;
    try {
      let res = yield ApiCaller.Put(`logistics_partners/${id}/${params}`);
      if (res.status == 200) {
        info("success", "Logistics Parther Status Changed Successfully!");
        yield put(DashboardAction.logisticsActivationSuccess(res.data.data));

        cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
      } else {
        yield put(DashboardAction.logisticsActivationError());
        info("error", res.data.error.message || 'Error Occured');
      }
    } catch (err) {
      yield put(DashboardAction.logisticsActivationError());
      info("error", 'Error Occured');

    }
  }

  static *LogisticRejection(action) {
    const { id, cb, params } = action;
    try {
      let res = yield ApiCaller.Put(`logistics_partners/${id}/${params}`);
      if (res.status == 200) {
        yield put(DashboardAction.logisticsRejectionSuccess(res.data.data));
        cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
      } else {
        yield put(DashboardAction.logisticsRejectionError());
        info("error", "Error Occured");
      }
    } catch (err) {
      yield put(DashboardAction.logisticsRejectionError());
      info("error", "Error Occured");

    }
  }

  static *DashboardOrders(action) {
    const { params, id } = action;
    console.log("params===>", params);
    const obj = { ...params };
    if (!obj.start_date || !obj.end_date) {
      delete obj.start_date;
      delete obj.end_date;
    }
    const qureyParams = new URLSearchParams(obj).toString();
    console.log("queryParams===>", qureyParams);

    try {
      let res = yield ApiCaller.Get(
        `rmx_companies/${id}/orders?${qureyParams}`,
        {
          "Content-Type": "application/json",
        }
      );
      console.log("orderRes-->", res);

      if (res.status == 200) {
        yield put(
          DashboardAction.getOrderSuccess(res.data.data, res.data.meta)
        );

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(DashboardAction.getOrderError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(DashboardAction.getOrderError());
    }
  }

  static *getLogisticsOrders(action) {
    const { params, id } = action;
    console.log("checkingId===>", id);
    const obj = { ...params };
    if (!obj.start_date || !obj.end_date) {
      delete obj.start_date;
      delete obj.end_date;
    }
    const qureyParams = new URLSearchParams(obj).toString();

    try {
      let res = yield ApiCaller.Get(
        `logistics_partners/${id}/orders?${qureyParams}`,
        {
          "Content-Type": "application/json",
        }
      );

      if (res.status == 200) {
        yield put(
          DashboardAction.getLogisticsOrderSuccess(res.data.data, res.data.meta)
        );

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(DashboardAction.getLogisticsOrderError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(DashboardAction.getLogisticsOrderError());
    }
  }

  static *AllCustomer(action) {
    const { params } = action;

    const qureyParams = new URLSearchParams(params).toString();

    try {
      let res = yield ApiCaller.Get(`contractors?${qureyParams}`, {
        "Content-Type": "application/json",
      });
      if (res.status == 200) {
        yield put(
          DashboardAction.getAllCustomerSuccess(res.data.data, res.data.meta)
        );

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(DashboardAction.getAllCustomerError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(DashboardAction.getAllCustomerError());
    }
  }

  static *AllowCustomer(action) {
    const { userId, cb, payload, metaData } = action;

    try {
      let res = yield ApiCaller.Put(`/contractors/${userId}/activate`);
      if (res.status == 200) {
        // yield put(
        //   DashboardAction.allowCustomerSuccess(res.data.data, res.data.meta)
        // );
        yield put(DashboardAction.getAllCustomerReq(metaData));
        cb() && cb();
        info('success', 'Contractor Status Changed Successfully!')
      } else {
        yield put(DashboardAction.allowCustomerError());
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(DashboardAction.allowCustomerError());
    }
  }

  static *RestrictCustomer(action) {
    const { userId, cb, payload, metaData } = action;
    try {
      let res = yield ApiCaller.Put(`/contractors/${userId}/deactivate`);
      if (res.status == 200) {
        // yield put(
        //   DashboardAction.allowCustomerSuccess(res.data.data, res.data.meta)
        // );
        yield put(DashboardAction.getAllCustomerReq(metaData));
        cb() && cb();
        info('success', 'Contractor Status Changed Successfully!')

      } else {
        yield put(DashboardAction.restrictCustomerError());
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(DashboardAction.restrictCustomerError());
    }
  }

  static *getOrderDetailById(action) {
    const { id, orderId, cb } = action;

    try {
      let res = yield ApiCaller.Get(`rmx_companies/${id}/orders/${orderId}`, {
        "Content-Type": "application/json",
      });
      if (res.status == 200) {
        res.data.data.driver_orders?.sort((a, b) => {
          if (a.is_lead && !b.is_lead) {
            return -1; // `a` should come before `b`
          } else if (!a.is_lead && b.is_lead) {
            return 1; // `b` should come before `a`
          } else {
            return 0; // Maintain the original order
          }
        });
        yield put(DashboardAction.getOrderDetailSuccess(res.data.data));
        cb() && cb();
      } else {
        yield put(DashboardAction.getOrderDetailError());
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(DashboardAction.getOrderDetailError());
    }
  }

  static *getLogisticDetailById(action) {
    const { id, orderId, cb } = action;

    try {
      let res = yield ApiCaller.Get(
        `logistics_partners/${id}/orders/${orderId}`,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(DashboardAction.getLogisticDetailSuccess(res.data.data));
        cb() && cb();
      } else {
        yield put(DashboardAction.getLogisticDetailError());
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(DashboardAction.getLogisticDetailError());
    }
  }

  static *orderAprovalMiddleWare(action) {
    const { id, cb, params, logId } = action;
    const companyId = JSON.parse(localStorage.getItem("platform_owner"))?.[1]
      ?.platform_owner?.id;
    try {
      let res;
      if (params == "dispatch") {
        res = yield ApiCaller.Post(
          `rmx_companies/${companyId}/orders/${id}/${params}`,
          { logistics_partner_id: logId }
        );
        if (res.status === 200) {
          if (params == "dispatch") {
            info("success", "order dispatched successfully");
          }
        }
      } else {
        res = yield ApiCaller.Put(
          `rmx_companies/${companyId}/orders/${id}/${params}`,
          {
            "Content-Type": "application/json",
          }
        );
      }

      if (res.status == 200) {
        yield put(DashboardAction.getOrderDetailSuccess(res.data.data));
        cb() && cb();
      } else {
        yield put(DashboardAction.getOrderDetailError());
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(DashboardAction.getOrderDetailError());
    }
  }
  static *deleteDocMiddleWare(action) {
    const { orderId, docId, cb } = action;
    const companyId = JSON.parse(localStorage.getItem("platform_owner"))?.[1]
      ?.platform_owner?.id;
    try {
      let res = yield ApiCaller.Delete(
        `rmx_companies/orders/${orderId}/${cb.params}/${docId}`,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(DashboardAction.getOrderDetailReq(orderId));
        info("success", "File Deleted Successfully!");

        cb() && cb();
      } else {
        yield put(DashboardAction.getOrderDetailError());
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(DashboardAction.getOrderDetailError());
    }
  }

  static *uploadDocMiddleWare(action) {
    const { orderId, payload, cb } = action;
    const companyId = JSON.parse(localStorage.getItem("platform_owner"))?.[1]
      ?.platform_owner?.id;
    let formData = new FormData();
    for (const key in payload) {
      formData.append(key, payload[key]);
    }
    try {
      let res = yield ApiCaller.Post(
        `rmx_companies/orders/${orderId}/${cb.params}`,
        formData
      );
      if (res.status == 200) {
        yield put(DashboardAction.getOrderDetailSuccess(res.data.data));
        info("success", "File Uploaded Successfully!");

        cb() && cb();
      } else {
        yield put(DashboardAction.getOrderDetailError());
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(DashboardAction.getOrderDetailError());
    }
  }
  static *getNotificationMiddleWare() {
    const companyId = JSON.parse(localStorage.getItem("platform_owner"))?.[1]
      ?.platform_owner?.id;
    try {
      let res = yield ApiCaller.Get(`rmx_companies/${companyId}/notifications`);
      if (res.status == 200) {
        yield put(DashboardAction.getNotificationSuccess(res.data.data));
      } else {
        yield put(DashboardAction.getNotificationError());
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(DashboardAction.getNotificationError());
    }
  }
  static *markAsReadMiddleWare(action) {
    const { notificationId } = action;
    const companyId = JSON.parse(localStorage.getItem("platform_owner"))?.[1]
      ?.platform_owner?.id;
    try {
      let res = yield ApiCaller.Put(
        `notifications/${notificationId}/mark_read`
      );
      if (res.status == 200) {
      } else {
        yield put(DashboardAction.getNotificationError());
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(DashboardAction.getNotificationError());
    }
  }
  static *getLogisticsMiddleWare(action) {
    const { notificationId } = action;
    const companyId = JSON.parse(localStorage.getItem("platform_owner"))?.[1]
      ?.platform_owner?.id;
    try {
      let res = yield ApiCaller.Get(
        `logistics_partners/active?per_page=${10000}&platform_owner_id=${companyId}`
      );
      if (res.status == 200) {
        yield put(DashboardAction.getLogisticsSuccess(res.data.data));
      } else {
        yield put(DashboardAction.getLogisticsError());
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(DashboardAction.getLogisticsError());
    }
  }
  static *getLogPartberMiddleWare(action) {
    const { notificationId } = action;
    const companyId = JSON.parse(localStorage.getItem("platform_owner"))?.[1]
      ?.platform_owner?.id;
    try {
      let res = yield ApiCaller.Get(
        `rmx_companies/${companyId}/logistics_partners`
      );
      if (res.status == 200) {
        yield put(DashboardAction.getLogPartnerSuccess(res.data.data));
      } else {
        yield put(DashboardAction.getLogPartnerError());
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(DashboardAction.getLogPartnerError());
    }
  }

  static *markAsFavMiddleWare(action) {
    const { id } = action;
    const companyId = JSON.parse(localStorage.getItem("platform_owner"))?.[1]
      ?.platform_owner?.id;
    try {
      let res = yield ApiCaller.Post(
        `rmx_companies/${companyId}/logistics_partners/${id}`
      );
      if (res.status == 201) {
        yield put(DashboardAction.getLogPartnerReq());
        yield put(DashboardAction.getLogisticsReq());
      } else {
        yield put(DashboardAction.getLogPartnerError());
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(DashboardAction.getLogPartnerError());
    }
  }
}
